import React, { useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import LibraryPage from './LibraryPage';
import StoryHistory from './StoryHistory';

export default function StoriesHubPage({ t = {}, allowPublic = true }) {
  const [source, setSource] = useState('mine');
  const sourceSelector = allowPublic ? (
    <FormControl size="small" sx={{ minWidth: { xs: 0, sm: 220 }, flex: { xs: 1, sm: '0 0 auto' } }}>
      <InputLabel id="stories-source-label">{t.stories_source || 'Story library'}</InputLabel>
      <Select
        id="stories-source"
        labelId="stories-source-label"
        value={source}
        label={t.stories_source || 'Story library'}
        onChange={(event) => setSource(event.target.value)}
      >
        <MenuItem value="mine">{t.stories_source_mine || 'My stories'}</MenuItem>
        <MenuItem value="public">{t.stories_source_public || 'Public stories'}</MenuItem>
      </Select>
    </FormControl>
  ) : null;

  return (
    <Box sx={{ width: '100%' }}>
      {source === 'public' && allowPublic
        ? <LibraryPage t={t} showTitle={false} headerContent={sourceSelector} />
        : <StoryHistory t={t} showTitle={!allowPublic} headerContent={sourceSelector} />}
    </Box>
  );
}
